import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { IMenu } from '@core/models/interfaces/menu.interface';
import { GenericLink } from '@core/models/types/generic-link.type';
import { MenuItem } from '@core/models/types/menu-item.type';
import { ImageUrlService } from '@services/assets-S3/image-url.service';
import { ChatbotService } from '@shared/services/chatbot.service';
import { FooterContentComponent } from './footer-content/footer-content.component';
import { DPO_LINK, termosInformacao } from './footer-data';
import { InternalLinksComponent } from './internal-links/internal-links.component';
import { PaymentBrandsComponent } from './payment-brands/payment-brands.component';
import { SocialMediaListComponent } from './social-media-list/social-media-list.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    InternalLinksComponent,
    SocialMediaListComponent,
    PaymentBrandsComponent,
    FooterContentComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  footerMenu!: GenericLink[];

  @Input() set menu(values: IMenu[]) {
    this.footerMenu = this.flatMenu(values);
    this.helpItem = this.footerMenu.pop();
  }

  helpItem!: GenericLink | undefined;
  financialStatementsItem = {
    title: 'Repasse',
    url: 'https://www.lidercap.com.br/demostrativo-financeiro.html#resgatesinstituicoes',
  };

  legalTermsList: GenericLink[] = termosInformacao;
  logoUrl!: string;

  dpoLink = DPO_LINK;

  constructor(
    private imageUrlService: ImageUrlService,
    private chatbotService: ChatbotService
  ) {}

  ngOnInit() {
    this.getLogoUrl();
  }

  getLogoUrl() {
    this.logoUrl = this.imageUrlService.getImageUrl(
      'conteudo/img/logo/logo-tele-premios.webp'
    );
  }

  flatMenu(values: IMenu[]): GenericLink[] {
    return values.flatMap((item: IMenu) => {
      if (item.submenus) {
        return item.submenus.map(submenu =>
          this.formatSubMenuItem(item, submenu)
        );
      }
      return {
        title: item.title,
        url: item?.url,
        additionalTitle: item?.additionalTitle,
      } as GenericLink;
    });
  }

  formatSubMenuItem(menu: MenuItem, submenu: MenuItem): GenericLink {
    return {
      title: `${menu.title} ${submenu.title}`,
      url: submenu?.url,
    };
  }

  openChatbot(): void {
    this.chatbotService.showChat();
  }
}
